/** Separa colisões de colunas e cartões para impedir interferência entre alvos. */
import { closestCenter, closestCorners, pointerWithin, rectIntersection, type CollisionDetection } from '@dnd-kit/core';

export const kanbanCollision: CollisionDetection = args => {
  if (args.active.data.current?.type === 'column') {
    const containers = args.droppableContainers.filter(c => String(c.id).startsWith('column-'));
    const hits = rectIntersection({ ...args, droppableContainers: containers });
    return hits.length ? hits : closestCenter({ ...args, droppableContainers: containers });
  }
  const hits = pointerWithin(args);
  return hits.length ? hits : closestCorners(args);
};